import React from 'react';
import { Col, Row } from 'antd';
import QRCode from 'qrcode.react';

import logo from '../../assets/images/logo-dark.svg';

import './Payment.css';

const appStoreLink = 'https://apps.apple.com/us/app/spoddr-collect-trade-spots/id1512973874';
const playStoreLink = 'https://play.google.com/store/apps/details?id=com.spoddr.both';

const goToUrl = (url) => (e) => {
  e.stopPropagation();
  window.location.href = url;
};

function PaymentForm() {
  return (
    <div className="AppWrapper">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      <h1 className="h1 mb-4">Download app</h1>
      <div className="AppContentWrapper">
        <Row>
          <Col span={12} className="gutter-row border-right">
            <h2 className="h2">AppStore</h2>
            <div className="gutter-box text-center">
              <QRCode
                value={appStoreLink}
                includeMargin={true}
                fgColor={'#540078'}
                size={160}
                onClick={goToUrl(appStoreLink)}
              />
            </div>
          </Col>
          <Col span={12} className="gutter-row">
            <h2 className="h2">Play Market</h2>
            <div className="gutter-box text-center">
              <QRCode
                value={playStoreLink}
                includeMargin={true}
                fgColor={'#1890ff'}
                size={160}
                onClick={goToUrl(playStoreLink)}
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default PaymentForm;




// WEBPACK FOOTER //
// ./src/containers/Download/index.js